<span mat-dialog-title>{{ 'ACCOUNT.CLOSE_ACCOUNT.TITLE' | translate }}</span>
<div mat-dialog-content>
  <p>{{ 'ACCOUNT.CLOSE_ACCOUNT.INFO' | translate }}</p>
</div>
<ng-container *ngIf="formState$ | async as formState">
  <mat-form-field appearance="fill" class="password-input">
    <mat-label>{{ 'ACCOUNT.CLOSE_ACCOUNT.ENTER_PASSWORD' | translate }}</mat-label>
    <input matInput type="password" [ngrxFormControlState]="formState"
  /></mat-form-field>
</ng-container>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close class="dark-plain-button">{{ 'GENERAL.CANCEL' | translate }}</button>
  <!--todo: implement logic-->
  <button mat-button mat-dialog-close color="warn">{{ 'ACCOUNT.PROFILE.CLOSE_ACCOUNT' | translate }}</button>
</div>
